import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { IPlaylistMusicService } from 'src/app/player/interfaces';
import { Recording } from 'src/app/recordings/state';
import { PitchPlaylistQuery } from '../shared/pitch-playlist/state';

@Injectable({
  providedIn: 'root'
})
export class PitchPlaylistMusicService implements IPlaylistMusicService {
  constructor(private pitchQuery: PitchPlaylistQuery) {}

  activeSong$: Subject<Recording> = new Subject<Recording>();
  playlist$: Subject<any> = new Subject();
  playlistPanelOpened$: Subject<boolean> = new BehaviorSubject<boolean>(false);

  playlistQuery$ = this.pitchQuery.selectCurrentPitch().subscribe(pitch => {
    this.playlist$.next(pitch);
    const [activeSong] = pitch.songs;
    this.activeSong$.next(activeSong as Recording);
  });

  private recording: Recording;

  setActiveSong(song: Recording): void {
    if (!song) {
      return;
    }
    this.recording = song;
    this.activeSong$.next(song);
  }

  getActiveSong(): Recording {
    return this.recording;
  }

  togglePlaylistPanel(): void {}
}
